import React from 'react';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import useDeviationGroupListPopup from '../../../../DeviationGroupListPopup/useDeviationGroupListPopup';
import { ResourceType } from '../../../../types/resource';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import GroupCard from '../../../../GroupCard';
import s from './Groups.scss';
var Groups = function (_a) {
    var _b;
    var block = _a.block, parentDeviation = _a.deviation;
    var onSeeAllClick = useDeviationGroupListPopup(parentDeviation);
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block, onSeeAllClick: onSeeAllClick },
        React.createElement("div", { className: s['grid'] }, (_b = block.groups) === null || _b === void 0 ? void 0 : _b.map(function (group, index) { return (React.createElement(GroupCard, { key: group.userId, username: group.username, imageUrl: group.usericon, className: s['grid-item'], biData: BiData({
                evid: 101,
                typeid: ResourceType.GROUP,
                itemid: group.userId,
                sectionname: BiContextProvidedValue,
                _rankIndex: index,
            }) })); }))));
};
Groups.displayName = 'Groups';
export default Groups;
//# sourceMappingURL=Groups.js.map